import { render, staticRenderFns } from "./supplierPage.vue?vue&type=template&id=55d0f878&scoped=true"
import script from "./supplierPage.vue?vue&type=script&lang=js"
export * from "./supplierPage.vue?vue&type=script&lang=js"
import style0 from "./supplierPage.vue?vue&type=style&index=0&id=55d0f878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d0f878",
  null
  
)

export default component.exports